export default __webpack_public_path__ + "static/media/milestone 800.4ab2484a.svg";